import classNames from 'classnames'
import React, { LegacyRef } from 'react'
import { twMerge } from 'tailwind-merge'
import NumberFormat, {
	NumberFormatValues,
	SourceInfo,
} from 'react-number-format'

interface InputProps {
	type: 'password' | 'text' | 'email' | 'url' | 'number' | 'tel'
	name?: string
	id?: string
	placeholder?: string
	isValid?: boolean
	format?: string
	className?: string
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
	onValueChange?: (values: NumberFormatValues, sourceInfo: SourceInfo) => void
	defaultValue?: string
	value?: string
	thousandSeparator?: boolean | string
	decimalSeparator?: string
	step?: string
	prefix?: string
	disabled?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	(
		{
			type,
			id,
			placeholder,
			isValid,
			onValueChange,
			name,
			onChange,
			defaultValue,
			value,
			disabled,
			className,
			step,
			...props
		},
		ref
	) => {
		if (
			(props.format ||
				props.thousandSeparator ||
				props.prefix ||
				props.decimalSeparator) &&
			(type === 'text' || type === 'tel')
		) {
			return (
				<NumberFormat
					name={name}
					ref={ref as LegacyRef<NumberFormat<unknown>> | undefined}
					type={type}
					id={id}
					value={value}
					disabled={disabled}
					className={twMerge(
						'bg-transparent border dark:border-white/15 border-opacity-30 border-[#8493ac] rounded-md mb-4 px-[15px] placeholder:text-base dark:placeholder:opacity-40 dark:focus:border-white/40 focus:border-gray-500/40 py-[15px] text-sm text-white opacity-100 w-full outline-none transition-shadow transition-border duration-400 ease-in-out relative disabled:pointer-events-none appearance-none disabled:bg-none disabled:shadow-none',
						classNames(className, {
							'border-red-500/80 dark:border-red-500/80 text-red-500 dark:text-red-500 placeholder:text-red-500 dark:placeholder:text-red-500':
								!isValid && isValid !== undefined,
							'text-opacity-40 bg-opacity-20': disabled,
						})
					)}
					defaultValue={defaultValue}
					onValueChange={onValueChange}
					placeholder={placeholder}
					{...props}
				/>
			)
		}

		return (
			<input
				onChange={onChange}
				ref={ref}
				type={type}
				id={id}
				name={name}
				value={value}
				disabled={disabled}
				step={step}
				className={twMerge(
					'bg-none placeholder:hidden dark:border-white/20 border-[#8493ac]/10 rounded-md mb-4 px-[15px] border-2 dark:focus:border-blue-500/90 focus:border-gray-300/50 py-[10px] text-sm text-[#5b5661] font-medium opacity-100 w-full outline-none transition-all duration-400 ease-in-out relative disabled:pointer-events-none appearance-none disabled:bg-none disabled:shadow-none',
					classNames(className, {
						'border-red-500/80 dark:border-red-500/80 text-red-500 dark:text-red-500':
							!isValid && isValid !== undefined,
						'text-opacity-40 bg-opacity-20': disabled,
					})
				)}
				defaultValue={defaultValue}
				placeholder={placeholder}
				{...props}
			/>
		)
	}
)

export default Input
